import type { ErrorMap } from '@/app/error-registry';

/**
 * Error codes confirmed by backend's frontend integration guide (`§5 Error Codes`,
 * `feature/project-templates-core`). `ProjectTemplate.*` covers every template endpoint;
 * `Project.NotFound`/`Project.NoBoards` are specific to `save-as-template`, whose source
 * resource is a project, not a template.
 */
export const PROJECT_TEMPLATES_CREATE_ERROR_MAP: ErrorMap = {
  POST: {
    'ProjectTemplate.InvalidSector': 'projectTemplates:apiErrors.sectorRequired',
    'ProjectTemplate.InvalidStructure': 'projectTemplates:apiErrors.invalidStructure',
    'ProjectTemplate.TitleRequired': 'projectTemplates:apiErrors.titleRequired',
    'ProjectTemplate.TitleTooLong': 'projectTemplates:apiErrors.titleTooLong',
    'ProjectTemplate.NameAlreadyExists': 'projectTemplates:apiErrors.duplicateName',
    validation: 'projectTemplates:apiErrors.createValidation',
    default: 'projectTemplates:apiErrors.createDefault',
  },
};

export const PROJECT_TEMPLATES_UPDATE_ERROR_MAP: ErrorMap = {
  PUT: {
    'ProjectTemplate.NotFound': 'projectTemplates:apiErrors.notFound',
    'ProjectTemplate.AccessDenied': 'projectTemplates:apiErrors.forbiddenRole',
    'ProjectTemplate.SystemPresetImmutable': 'projectTemplates:apiErrors.forbiddenSystemTemplate',
    'ProjectTemplate.NameAlreadyExists': 'projectTemplates:apiErrors.duplicateName',
    'ProjectTemplate.InvalidSector': 'projectTemplates:apiErrors.sectorRequired',
    'ProjectTemplate.InvalidStructure': 'projectTemplates:apiErrors.invalidStructure',
    'ProjectTemplate.TitleRequired': 'projectTemplates:apiErrors.titleRequired',
    'ProjectTemplate.TitleTooLong': 'projectTemplates:apiErrors.titleTooLong',
    validation: 'projectTemplates:apiErrors.updateValidation',
    default: 'projectTemplates:apiErrors.updateDefault',
  },
};

export const PROJECT_TEMPLATES_DELETE_ERROR_MAP: ErrorMap = {
  DELETE: {
    'ProjectTemplate.NotFound': 'projectTemplates:apiErrors.notFound',
    'ProjectTemplate.AccessDenied': 'projectTemplates:apiErrors.forbiddenRole',
    'ProjectTemplate.SystemPresetImmutable': 'projectTemplates:apiErrors.forbiddenSystemTemplate',
    default: 'projectTemplates:apiErrors.deleteDefault',
  },
};

export const PROJECT_TEMPLATES_INSTANTIATE_ERROR_MAP: ErrorMap = {
  POST: {
    'ProjectTemplate.NotFound': 'projectTemplates:apiErrors.notFound',
    'ProjectTemplate.AccessDenied': 'projectTemplates:apiErrors.forbiddenRole',
    validation: 'projectTemplates:apiErrors.instantiateValidation',
    default: 'projectTemplates:apiErrors.instantiateDefault',
  },
};

export const PROJECT_TEMPLATES_SAVE_ERROR_MAP: ErrorMap = {
  POST: {
    'Project.NotFound': 'projectTemplates:apiErrors.sourceProjectNotFound',
    'Project.NoBoards': 'projectTemplates:apiErrors.sourceProjectNoBoards',
    'ProjectTemplate.InvalidSector': 'projectTemplates:apiErrors.sectorRequired',
    'ProjectTemplate.TitleRequired': 'projectTemplates:apiErrors.titleRequired',
    'ProjectTemplate.NameAlreadyExists': 'projectTemplates:apiErrors.duplicateName',
    default: 'projectTemplates:apiErrors.saveDefault',
  },
};
